const tokenPrefix = 'Bearer'
const tokenSuffix = 'a_t';

export let storage = {};

export const setAuthToken = (token) => localStorage.setItem(tokenSuffix, JSON.stringify(token))
export const getAuthToken = () => {
  const token = JSON.parse(localStorage.getItem(tokenSuffix));
  return token && `${tokenPrefix} ${token}`
};

export const removeAuthToken = () => localStorage.removeItem(tokenSuffix)

export const clearStorage = () => {
  storage = {}
}